import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { api } from '../api/client';

/** Redirects first-time customers into the Welcome Experience. */
export const OnboardingGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading, markOnboardingComplete } = useAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [needs, setNeeds] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (isLoading || !user || user.role !== 'customer') {
      setChecking(false);
      setNeeds(false);
      return;
    }

    if (user.needsOnboarding === false) {
      setNeeds(false);
      setChecking(false);
      return;
    }

    api
      .getExperience()
      .then((state) => {
        if (cancelled) return;
        setNeeds(state.needsOnboarding);
        if (!state.needsOnboarding) markOnboardingComplete();
      })
      .catch(() => {
        if (!cancelled) setNeeds(Boolean(user.needsOnboarding));
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user, isLoading, markOnboardingComplete, location.pathname]);

  if (isLoading || checking) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-xs text-fog" role="status">
        …
      </div>
    );
  }

  if (
    needs &&
    !location.pathname.startsWith('/customer/welcome') &&
    !location.pathname.startsWith('/customer/upgrade')
  ) {
    return <Navigate to="/customer/welcome" replace />;
  }

  return <>{children}</>;
};
